import { Box } from '@mui/material';
import { ReactComponent as LogoArSmartflow } from '../../../assets/logo/main-logo.svg';
import { ReactComponent as LogoArSmartflowTitle } from '../../../assets/logo/main-title-logo.svg';

const MainLogo = () => {
    return (
        <Box
            width={1}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
            gap={3}
        >
            <LogoArSmartflow />
            <LogoArSmartflowTitle width={'100%'} />
        </Box>
    );
};

export default MainLogo;
